<template>
<div class="guesses">
  <p>Guesses:</p>
  <table>
    <tr>
      <th>Number</th>
      <th>Score</th>
    </tr>
    <tr v-for="guess in guesses" v-bind:key="guess.id" v-bind:class="{ winner: guess.isWinner, loser: guess.isLoser }">
      <td>{{ guess.number }}</td>
      <td>{{ guess.score }}</td>
    </tr>
  </table>
</div>
</template>

<script>
export default {
  name: 'Guesses',
  props: ['guesses']
}
</script>

<style scoped>
.guesses {
  height: 100%;
}

table {
  margin: auto;
  border-collapse: collapse;
}

th,
td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.winner {
  background-color: #66ff66;
  color: black;
}

tr.winner:hover {
  background-color: #b3ffb3;
  color: black;
}

.loser {
  background-color: #ff3333;
  color: black;
}

tr.loser:hover {
  background-color: #ff9999;
}

tr:hover {
  background-color: #F5F5F5;
}
</style>
